module.exports = __webpack_public_path__ + "static/media/shopify12.a2ec61a6.png";